import type { TPlanButton } from "@molecules/PlanButton/types";
import type { TPlans } from "@/components/templates/Plans/types";

type TPlanButtonProps = Array<
  {
    id: TPlans;
  } & Pick<TPlanButton, "title" | "description">
>;

export const plansButtons: TPlanButtonProps = [
  {
    id: "B2C",
    title: "Planos B2C",
    description: "Ideal para quem vende para o consumidor final.",
  },
  {
    id: "B2B",
    title: "Planos B2B",
    description: "Ideal para quem vende para empresas e busca por decisores.",
  },
];
